import { ReactComponent as IconCar } from 'assets/icons/additional-services/ic-car.svg';
// import { ReactComponent as IconRole } from 'assets/icons/additional-services/ic-role.svg';
import { ReactComponent as IconGlass } from 'assets/icons/additional-services/ic-glass.svg';
import { ReactComponent as IconHammer } from 'assets/icons/additional-services/ic-hammer.svg';
import { ReactComponent as IconContents } from 'assets/icons/additional-services/ic-contents.svg';
import { ReactComponent as IconAutoParts } from 'assets/icons/additional-services/ic-auto-parts.svg';
import { ReactComponent as IconAccessories } from 'assets/icons/additional-services/ic-accessories.svg';
import { ReactComponent as IconDefaultService } from 'assets/icons/additional-services/ic-default-service.svg';

import { ReactComponent as IconRoleMoto } from 'assets/icons/additional-services/ic-role-moto.svg';
import { ReactComponent as IconHammerMoto } from 'assets/icons/additional-services/ic-hammer-moto.svg';

import { ReactComponent as IconAutoHome } from 'assets/icons/additional-services/ic-auto-home.svg';
import { ReactComponent as IcPaintingHammer } from 'assets/icons/additional-services/ic-painting-hammer.svg';

export const ParseQuotation = (codProduct: number) => {
    switch (codProduct) {
        case 2302:
            return <IconHammer />;
        case 2303:
            return <IconGlass />;
        case 2304:
            return <IconAccessories />;
        case 2420:
            return <IconCar />;
        case 2424:
            return <IconAutoParts />;
        case 2425:
            return <IconContents />;
        case 2453:
            return <IconRoleMoto />;
        case 2574:
            return <IcPaintingHammer />;
        case 2575:
            return <IconHammerMoto />;
        case 2580: case 2581:
            return <IconAutoHome />;
        case 2605:
            return <IconHammer />;
        default:
            return <IconDefaultService />;
    }
}